<template>
  <div class="news" v-if="load">
    <div id="block-storyrun" class="block__wrapper" style="display: block;">
      <article role="article" class="clearfix news-run-wide news-run row collapse crop-middle">
        <div class="columns small-12 large-7 xlarge-8 xxlarge-8 xxxlarge-8" aria-hidden="true">
          <div
            class="field field--name-field-news-cover-image field--type-entity-reference field--label-hidden field__item"
          >
            <article class="view-mode-captionless-medium media media-image">
              <div
                class="field field--name-image field--type-image field--label-hidden field__item"
              >
                <img :src="top_list0.cover" alt typeof="foaf:Image" />
              </div>
            </article>
          </div>
        </div>
        <div class="columns small-12 large-5 xlarge-4 xxlarge-4 xxxlarge-4">
          <div class="content row collapse">
            <div class="news-category">
              <a href="javascript:;">公司动态</a>
            </div>
            <a :href="`/newsDetails?id=${top_list0.id}`" class="padme">
              <div class="columns small-12 medium-12 large-12 xlarge-12 xxlarge-12 xxxlarge-12">
                <h2>
                  <span>{{top_list0.title}}</span>
                  <span class="show-for-sr">.</span>
                </h2>
              </div>
              <div class="columns small-12 medium-12 large-12 xlarge-12 xxlarge-12 xxxlarge-12">
                <p>{{top_list0.brief}}</p>
                <div class="readmore" aria-hidden="true">查看全文</div>
              </div>
            </a>
          </div>
        </div>
      </article>
    </div>
    <!-- 2 -->
    <div class="paragraph clearfix paragraph--type--paragraph-view paragraph--view-mode--default">
      <div
        class="field field--name-field-paragraph-block field--type-block-field field--label-hidden field__items"
      >
        <div class="field__item">
          <div class="news-run">
            <article role="article" class="clearfix news-run-wide news-run row collapse crop-top">
              <div
                class="columns small-12 large-7 xlarge-8 xxlarge-8 xxxlarge-8"
                aria-hidden="true"
              >
                <div
                  class="field field--name-field-news-cover-image field--type-entity-reference field--label-hidden field__item"
                >
                  <article class="view-mode-captionless-medium media media-image">
                    <div
                      class="field field--name-image field--type-image field--label-hidden field__item"
                    >
                      <img :src="top_list1.cover" alt typeof="foaf:Image" />
                    </div>
                  </article>
                </div>
              </div>
              <div class="columns small-12 large-5 xlarge-4 xxlarge-4 xxxlarge-4">
                <div class="content row collapse">
                  <div class="news-category">
                    <a href="javascript:;">公司动态</a>
                  </div>
                  <a :href="`/newsDetails?id=${top_list1.id}`" class="padme">
                    <div
                      class="columns small-12 medium-12 large-12 xlarge-12 xxlarge-12 xxxlarge-12"
                    >
                      <h2>
                        <span>{{top_list1.title}}</span>
                        <span class="show-for-sr">.</span>
                      </h2>
                    </div>
                    <div
                      class="columns small-12 medium-12 large-12 xlarge-12 xxlarge-12 xxxlarge-12"
                    >
                      <p>{{top_list1.brief}}</p>
                      <div class="readmore" aria-hidden="true">查看全文</div>
                    </div>
                  </a>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>
    <!-- 3 -->
    <div
      class="content-tile content-tile-subhead clearfix no-body has-cta subhead subhead-wide-light"
    >
      <h2>
        <div class="field field--name-name field--type-string field--label-hidden field__item">新闻动态</div>
      </h2>
    </div>
    <!-- 4 -->
    <div
      class="paragraph newsgrid clearfix paragraph--type--paragraph-view paragraph--view-mode--default"
    >
      <div
        class="field field--name-field-paragraph-block field--type-block-field field--label-hidden field__items"
      >
        <div class="field__item">
          <div class="news-run block">
            <article
              role="article"
              class="card news-teaser news-teaser-card-summary content-tile-flashcard content-tile-set-item"
              v-for="(item,index) in list"
              :key="index"
            >
              <a :href="`/newsDetails?id=${item.id}`">
                <div aria-hidden="true">
                  <div
                    class="field field--name-field-news-cover-image field--type-entity-reference field--label-hidden field__item"
                  >
                    <article class="view-mode-tile-small media media-image">
                      <div
                        data-blazy
                        class="blazy blazy--field blazy--image blazy--image--tile-small field field--name-image field--type-image field--label-hidden field__item blazy--on"
                      >
                        <div
                          class="media media--bundle--image media--blazy media--responsive media--image"
                        >
                          <img
                            class="media__image media__element b-lazy b-responsive b-loaded"
                            :src="item.cover"
                            alt
                            typeof="foaf:Image"
                          />
                        </div>
                      </div>
                    </article>
                  </div>
                </div>
                <div class="card-section">
                  <h3>
                    <span>{{item.title}}</span>
                    <span class="show-for-sr">.</span>
                  </h3>

                  <div class="show-for-large">
                    <p>{{item.brief}}</p>
                  </div>
                  <div class="readmore" aria-hidden="true">查看全文</div>
                </div>
              </a>
            </article>
          </div>
        </div>
      </div>
    </div>
    <!-- 5 -->
    <div class="page">
      <a-pagination :default-current="Number(cur_page)" :total="total" @change="checkPage" />
    </div>
  </div>
</template>

<script>
import { NewsList } from "@/api/index";
export default {
  components: {},
  data() {
    return {
      load: false,
      top_list0: null,
      top_list1: null,
      list: null,
      cur_page: this.$route.query.page || 1,
      total_page: 1,
      total: null,
    };
  },
  computed: {},
  watch: {},
  methods: {
    checkPage(index) {
      window.location.href = `/news?page=${index}`;
    },
  },
  created() {
    NewsList(
      {
        page: this.$route.query.page,
      },
      (res) => {
        this.load = true;
        this.$emit("complete", true);
        if (res.code == 0) {
          this.top_list0 =
            res.data.top_list.length > 0 ? res.data.top_list[0] : null;
          this.top_list1 =
            res.data.top_list.length > 1 ? res.data.top_list[1] : null;
          this.list = res.data.list.list;
          this.total_page = res.data.list.total_page;
          this.total = res.data.list.total;

          setTimeout(() => {
            window.SynchronousMaxHeight("card-section");
            window.SynchronousMinHeight("media__image", "media--image");
          }, 101);
        }
      }
    );
  },
  mounted() {
    document.getElementById("news-top-action").classList.add("is-active");
    window.onresize = function () {
      window.SynchronousMaxHeight("card-section");
      window.SynchronousMinHeight("media__image", "media--image");
    };
  },
};
</script>
<style lang='less' scoped>
.news-run img {
  margin: 0 !important;
}
.page {
  text-align: center;
  margin: 2rem 0;
}
@media print, screen and (max-width: 40em) {
  .news-category {
    display: none;
  }
  .content-tile-flashcard > a .card-section {
    box-shadow: none;
    width: 60%;
  }
  .newsgrid .news-run a {
    border-top: none;
  }
}
@media print, screen and (min-width: 120em) {
  #block-storyrun {
    width: 100%;
    .xxxlarge-8 {
      float: right;
    }
  }
}
</style>